import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'LeaseApp.PendingAndCanceledApplicationsDrawer.Title',
    defaultMessage: 'Pending and Canceled Applications',
  },
  screeningDetails: {
    id: 'LeaseApp.PendingAndCanceledApplicationsDrawer.ScreeningDetails',
    defaultMessage: 'Screening Details',
  },
  invalidOrMissingInformation: {
    id: 'LeaseApp.PendingAndCanceledApplicationsDrawer.InvalidOrMissingInformation',
    defaultMessage: 'Invalid or Missing Information',
  },
  applicantNeedingReview: {
    id: 'LeaseApp.PendingAndCanceledApplicationsDrawer.ApplicantNeedingReview',
    defaultMessage: 'Applicant Needing Review',
  },
  none: {
    id: 'LeaseApp.PendingAndCanceledApplicationsDrawer.None',
    defaultMessage: 'None',
  },
});

export default messages;
